import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  GET_CANDIDATES_MODAL_DATA,
  GET_CANDIDATE_RESUME_DETAILS,
  GET_FEEDBACK_CANDIDATE_DATA,
  GET_HIRE_CANDIDATE_LIST,
  GET_HIRE_CANDIDATE_RESUME_DETAILS,
  GET_HIRE_SUBMIT_FEEDBACK_STATUS,
  GET_HIRING_FEEDBACK_CANDIDATE_DATA,
  GET_HIRING_INTERVIEWER_LIST,
  GET_HIRING_SHORTLIST_DATA,
  GET_INTERVIEWERS_LIST,
  GET_INTERVIEW_QUESTION_LIST,
  GET_INTERVIEW_QUESTION_LIST_ID,
  GET_INTERVIEW_QUESTION_REVIEW_LIST,
  GET_INTERVIEW_SUBMIT_FEEDBACK_STATUS,
  GET_OFFER_DATA,
  GET_SHORLISTING_CANDIDATES_LIST,
  GET_SHORTLIST_DATA,
  GET_SHORTLIST_FILTER_DATA,
  GET_SHORTLIST_SUBMIT_FEEDBACK_STATUS,
  INTERVIEW_FEEDBACK,
  POST_OFFER_DATA,
  SHORTLIST_FEEDBACK,
  SUBMIT_FEEDBACK,
  SUBMIT_HIRING_FEEDBACK_DATA,
  VERIFY_CODE_SHORTLIST,
} from "./actionTypes";

import {
  getCandidateDataSuccess,
  getCandidateDatatFail,
  getCandidateModalDataDataFail,
  getCandidateModalDataSuccess,
  getCandidateResumeDetailsFail,
  getCandidateResumeDetailsSuccess,
  getCandidateShorlistingDataFail,
  getCandidateShorlistingDataSuccess,
  getHiringInterviewerListFail,
  getHiringInterviewerListSuccess,
  getInterviewQuestionListByIdFail,
  getInterviewQuestionListByIdSuccess,
  getInterviewQuestionListFail,
  getInterviewQuestionListReviewFail,
  getInterviewQuestionListReviewSuccess,
  getInterviewQuestionListSuccess,
  getInterviewerDetailsListFail,
  getInterviewerDetailsListSuccess,
  getOfferDetailsFail,
  getOfferDetailsSuccess,
  getShortListDataFail,
  getShortListDataSuccess,
  getSubmitHireFeedbackStatusFail,
  getSubmitHireFeedbackStatusSuccess,
  gethireCandidateListFail,
  gethireCandidateListSuccess,
  postOfferDataFail,
  postOfferDataSuccess,
  submitFeedBackFailed,
  submitFeedBackSuccessful,
  submitHireFeedbackFail,
  submitHireFeedbackSuccess,
  submitInterviewerFeedBackFailed,
  submitInterviewerFeedBackSuccessful,
  submitShortlistFeedBackFailed,
  submitShortlistFeedBackSuccessful,
  verifyShortlistCodeFailed,
  verifyShortlistCodeSuccessful,
} from "./actions";

import {
  feedbackCandidateShortList,
  getCandidateDataFeedback,
  getCandidateShortListing,
  getHiringStatus,
  getInterviewersList,
  getRequest,
  submitFeedBack,
} from "../../../helpers/fakebackend_helper";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
import { verifyData } from "../../../pages/Common/CommonFunctions/commonFunctions";

// submit feedback
function* submitFeedBackF({ payload: { feedBack } }) {
  try {
    var url = constClass.REST_API_SUBMIT_FEEDBACK;
    var responsJSON = yield call(submitFeedBack, url, feedBack);

    yield put(submitFeedBackSuccessful(responsJSON));
  } catch (error) {
    yield put(submitFeedBackFailed(error));
  }
}

// // verify code
// function* verifyVerficationCode({ payload: { code } }) {
//   try {
//     var url = constClass.REST_API_INTERVIEWER_VERIFY_CODE;

//     let req={
//       "verificationCode":code
//     }
//     var responsJSON = yield call(submitFeedBack, url, req);
//     yield put(verifyCodeSuccessful(responsJSON))
//   }
//   catch (error) {
//     yield put(verifyCodeFailed(error))
//   }
// }

// submit feedback form
function* submitInterviewerFeedBack({ payload: { feedBack } }) {
  try {
    var url = constClass.REST_API_INTERVIWER_FEEDBACK;
    var responsJSON = yield call(
      submitFeedBack,
      url,
      feedBack,
      feedBack.interviewCode,
    );
    yield put(submitInterviewerFeedBackSuccessful(responsJSON.message));
  } catch (error) {
    yield put(submitInterviewerFeedBackFailed(error));
  }
}

// verify code for shortlist manager
function* verifyShortlistVerficationCode({ payload: { code } }) {
  try {
    var url = constClass.REST_API_SHORTLIST_VERIFY_CODE;

    let req = {
      verificationCode: code,
    };
    var responsJSON = yield call(submitFeedBack, url, req);
    yield put(verifyShortlistCodeSuccessful(responsJSON));
  } catch (error) {
    yield put(verifyShortlistCodeFailed(error));
  }
}

// submit shortlist manager feedback form
function* submitShortlistFeedBack({ payload: { feedBack } }) {
  try {
    var url = constClass.REST_API_SHORTLIST_FEEDBACK;
    var responsJSON = yield call(submitFeedBack, url, feedBack, feedBack.code);
    yield put(submitShortlistFeedBackSuccessful(responsJSON.message));
  } catch (error) {
    yield put(submitShortlistFeedBackFailed(error));
  }
}

function* getInterviewersListHandler({ payload: { json } }) {
  try {
    let url =
      constClass.REST_API_INTERVIEWER_DETAILS +
      `?code=${json.code}&interviewId=${json.interviewId}`;
    let responsJson = yield call(getInterviewersList, url);
    yield put(getInterviewerDetailsListSuccess(responsJson));
  } catch (error) {
    yield put(getInterviewerDetailsListFail(error));
  }
}

function* getCandidateFeedbackDataHandler({ payload: { json } }) {
  try {
    let url =
      constClass.REST_API_CANDIDATE_DATA +
      `?code=${json.code}&interviewId=${json.interviewId}`;
    let responsJson = yield call(getCandidateDataFeedback, url);
    yield put(getCandidateDataSuccess(responsJson));
  } catch (error) {
    yield put(getCandidateDatatFail(error));
  }
}

function* getShortListDataHandler({ payload: { json } }) {
  try {
    let url =
      constClass.REST_API_SHORTLIST_DATA +
      `?code=${json.code}&interviewId=${json.interviewId}`;
    let responseJson = yield call(feedbackCandidateShortList, url);
    yield put(getShortListDataSuccess(responseJson));
  } catch (error) {
    yield put(getShortListDataFail(error));
  }
}

function* getCandidateResumeHandler({ payload: { json } }) {
  try {
    let url =
      constClass.REST_API_CANDIDATE_RESUME_DATA +
      `?code=${json.code}&interviewId=${json.interviewerId}`;
    let responseJson = yield call(feedbackCandidateShortList, url);
    yield put(getCandidateResumeDetailsSuccess(responseJson));
  } catch (error) {
    yield put(getCandidateResumeDetailsFail(error));
  }
}

//short list and filter handler
function* getShortListedCandidateshandler({ payload: { jsonData } }) {
  let url;
  if (verifyData(jsonData.jobId)) {
    url =
      constClass.REST_API_SHORTLIST_CANDIDATES +
      `?code=${jsonData.code}&jobId=${jsonData.jobId}&page=${jsonData.pageNumber}&pageSize=${jsonData.pageSize}`;
  } else {
    url =
      constClass.REST_API_SHORTLIST_CANDIDATES +
      `?code=${jsonData.code}&page=${jsonData.pageNumber}&pageSize=${jsonData.pageSize}`;
  }
  if (jsonData.sort !== undefined && jsonData.Sort !== null) {
    url = url + jsonData.sort;
  }

  if (
    jsonData.keyword !== undefined &&
    jsonData.keyword !== null &&
    jsonData.keyword !== ""
  ) {
    url = url + jsonData.keyword;
  }
  try {
    let response = yield call(getCandidateShortListing, url);
    yield put(getCandidateShorlistingDataSuccess(response));
  } catch (error) {
    yield put(getCandidateShorlistingDataFail(error));
  }
}

// shortlist sort data
function* getShortListedSortCandidateshandler({ payload: { jsonData } }) {
  let url;
  if (verifyData(jsonData.jobId)) {
    url =
      constClass.REST_API_SHORTLIST_CANDIDATES +
      `?code=${jsonData.code}&jobId=${jsonData.jobId}&page=${jsonData.pageNumber}&pageSize=${jsonData.pageSize}`;
  } else {
    url =
      constClass.REST_API_SHORTLIST_CANDIDATES +
      `?code=${jsonData.code}&page=${jsonData.pageNumber}&pageSize=${jsonData.pageSize}`;
  }
  if (jsonData.sort !== undefined && jsonData.Sort !== null) {
    url = url + jsonData.sort;
  }
  let url2 = "";
  if (jsonData.filter?.length > 0) {
    url2 = `&${encodeURIComponent(
      jsonData?.filter[0]?.filterName,
    )}=${encodeURIComponent(jsonData?.filter[0]?.value)}`;
    url = url + url2;
  }

  if (
    jsonData.keyword !== undefined &&
    jsonData.keyword !== null &&
    jsonData.keyword !== ""
  ) {
    url = url + jsonData.keyword;
  }
  try {
    let response = yield call(getCandidateShortListing, url);
    yield put(getCandidateShorlistingDataSuccess(response));
  } catch (error) {
    yield put(getCandidateShorlistingDataFail(error));
  }
}

function* viewShortListedCandidateDetailsHandler({ payload: data }) {
  try {
    let url = constClass.REST_API_CANDIDATES_MODAL_DETAILS;
    let response = yield call(
      getCandidateShortListing,
      url +
        `?candidateId=${data.data.candidateId}&shortlistCandidateId=${data.data.shortlistCandidateId}&code=${data.data.code}`,
    );
    yield put(getCandidateModalDataSuccess(response));
  } catch (error) {
    yield put(getCandidateModalDataDataFail(error));
  }
}
function* getOfferData(code) {
  try {
    let response = yield call(
      getCandidateShortListing,
      constClass.REST_API_Offer + code.payload,
    );
    yield put(getOfferDetailsSuccess(response));
  } catch (error) {
    yield put(getOfferDetailsFail(error));
  }
}

//post offer feedback
function* submitOfferFeedBack(feedBack) {
  try {
    var url = constClass.REST_API_POST_OFFER_DATA;

    var responsJSON = yield call(
      submitFeedBack,
      url,
      feedBack.payload,
      feedBack.payload.code,
    );
    yield put(postOfferDataSuccess(responsJSON.message));
  } catch (error) {
    yield put(postOfferDataFail(error));
  }
}

function* hireCandidateListHandler({ payload: { id } }) {
  try {
    let url = constClass.REST_API_HIRE_CANIDIDATE_LIST;
    let response = yield call(getCandidateShortListing, url + `?code=${id}`);
    yield put(gethireCandidateListSuccess(response));
  } catch (error) {
    yield put(gethireCandidateListFail(error));
  }
}

function* hireFeedBackSubmitHandler({ payload: { feedbackData } }) {
  try {
    let url = constClass.REST_API_HIRE_SUBMIT;
    let response = yield call(
      submitFeedBack,
      url,
      feedbackData,
      feedbackData.code,
    );
    yield put(submitHireFeedbackSuccess(response.message));
  } catch (error) {
    yield put(submitHireFeedbackFail(error));
  }
}

function* hireFeedBackStatusHandler({ payload: { code } }) {
  try {
    let url = constClass.REST_API_SUBMIT_HIRE_FEEDBACK;
    let response = yield call(getHiringStatus, url + `?code=${code}`);
    yield put(getSubmitHireFeedbackStatusSuccess(response));
  } catch (error) {
    yield put(getSubmitHireFeedbackStatusFail(error));
  }
}

function* shortListFeedBackStatusHandler({ payload: { code } }) {
  try {
    let url = constClass.REST_API_SHORTLIST_SUBMIT_STATUS;
    let response = yield call(
      getHiringStatus,
      url + `?shortlistCandidateId=${code}`,
    );
    yield put(getSubmitHireFeedbackStatusSuccess(response));
  } catch (error) {
    yield put(getSubmitHireFeedbackStatusFail(error));
  }
}

function* interviewerFeedBackStatusHandler({ payload: { json } }) {
  try {
    let url = constClass.REST_API_INTERVIEWER_STATUS;
    let response = yield call(
      getHiringStatus,
      url + `?code=${json.code}&&interviewId=${json.interviewId}`,
    );
    yield put(getSubmitHireFeedbackStatusSuccess(response));
  } catch (error) {
    yield put(getSubmitHireFeedbackStatusFail(error));
  }
}

// hiring interviewer list
function* getHiringInterviewerListHandler({ payload: { code } }) {
  try {
    let url = constClass.REST_API_HIRING_INTERVIEWER_LIST + `?code=${code}`;
    let responsJson = yield call(getInterviewersList, url);
    console.log("HIRING interview API response:", responsJson);
    yield put(getHiringInterviewerListSuccess(responsJson));
  } catch (error) {
    yield put(getHiringInterviewerListFail(error));
  }
}

function* getHireFeedbackCandidateDataHandler({ payload: { code } }) {
  try {
    let url = constClass.REST_API_HIRING_CANIDATE_DETAILS + `?code=${code}`;
    let responsJson = yield call(getCandidateDataFeedback, url);
    yield put(getCandidateDataSuccess(responsJson));
  } catch (error) {
    yield put(getCandidateDatatFail(error));
  }
}

function* getHiringShortListDataHandler({ payload: { code } }) {
  try {
    let url = constClass.REST_API_HIRING_SHORTLIST_DATA + `?code=${code}`;
    let responseJson = yield call(feedbackCandidateShortList, url);
    yield put(getShortListDataSuccess(responseJson));
  } catch (error) {
    yield put(getShortListDataFail(error));
  }
}

function* getHiredCandidateResumeHandler({ payload: { code } }) {
  try {
    let url =
      constClass.REST_API_HIRE_FEEDBACK_PAGE_CANDIDATE_MODAL + `?code=${code}`;
    let responseJson = yield call(feedbackCandidateShortList, url);
    yield put(getCandidateResumeDetailsSuccess(responseJson));
  } catch (error) {
    yield put(getCandidateResumeDetailsFail(error));
  }
}

function* getInterviewQuestionListHandler({ payload: { json } }) {
  try {
    let url =
      constClass.REST_API_INTERVIEW_QUESTION_DETAILS +
      `?code=${json.code}&interviewId=${json.interviewId}`;
    let responsJson = yield call(getRequest, url);
    yield put(getInterviewQuestionListSuccess(responsJson));
  } catch (error) {
    yield put(getInterviewQuestionListFail(error));
  }
}

function* getInterviewQuestionReviewListHandler({ payload: { json } }) {
  try {
    console.log("saga5");
    let url =
      constClass.REST_API_INTERVIEW_REVIEW_QUESTION_DETAILS +
      `?code=${json.code}&interviewId=${json.interviewId}`;
    let responsJson = yield call(getRequest, url);
    yield put(getInterviewQuestionListReviewSuccess(responsJson));
  } catch (error) {
    yield put(getInterviewQuestionListReviewFail(error));
  }
}

function* getInterviewQuestionListByIdHandler({ payload: { json } }) {
  try {
    let url =
      constClass.REST_API_INTERVIEW_QUESTION_BY_DETAILS +
      `?interviewId=${json?.interviewId}`;
    let responsJson = yield call(getRequest, url);
    yield put(getInterviewQuestionListByIdSuccess(responsJson));
  } catch (error) {
    yield put(getInterviewQuestionListByIdFail(error));
  }
}

function* submitFeedBackSaga() {
  yield takeEvery(SUBMIT_FEEDBACK, submitFeedBackF);
  // yield takeEvery(VERIFY_CODE, verifyVerficationCode);
  yield takeEvery(INTERVIEW_FEEDBACK, submitInterviewerFeedBack);
  yield takeEvery(VERIFY_CODE_SHORTLIST, verifyShortlistVerficationCode);
  yield takeEvery(SHORTLIST_FEEDBACK, submitShortlistFeedBack);
  yield takeEvery(GET_INTERVIEWERS_LIST, getInterviewersListHandler);
  yield takeEvery(GET_FEEDBACK_CANDIDATE_DATA, getCandidateFeedbackDataHandler);
  yield takeEvery(GET_SHORTLIST_DATA, getShortListDataHandler);
  yield takeEvery(GET_CANDIDATE_RESUME_DETAILS, getCandidateResumeHandler);
  yield takeEvery(
    GET_SHORLISTING_CANDIDATES_LIST,
    getShortListedCandidateshandler,
  );
  yield takeEvery(
    GET_CANDIDATES_MODAL_DATA,
    viewShortListedCandidateDetailsHandler,
  );
  yield takeLatest(GET_OFFER_DATA, getOfferData);
  yield takeEvery(POST_OFFER_DATA, submitOfferFeedBack);
  yield takeEvery(GET_HIRE_CANDIDATE_LIST, hireCandidateListHandler);
  yield takeEvery(SUBMIT_HIRING_FEEDBACK_DATA, hireFeedBackSubmitHandler);
  yield takeEvery(GET_HIRE_SUBMIT_FEEDBACK_STATUS, hireFeedBackStatusHandler);
  yield takeEvery(
    GET_SHORTLIST_SUBMIT_FEEDBACK_STATUS,
    shortListFeedBackStatusHandler,
  );
  yield takeEvery(
    GET_INTERVIEW_SUBMIT_FEEDBACK_STATUS,
    interviewerFeedBackStatusHandler,
  );
  yield takeEvery(GET_HIRING_INTERVIEWER_LIST, getHiringInterviewerListHandler);
  yield takeEvery(
    GET_HIRING_FEEDBACK_CANDIDATE_DATA,
    getHireFeedbackCandidateDataHandler,
  );
  yield takeEvery(GET_HIRING_SHORTLIST_DATA, getHiringShortListDataHandler);
  yield takeEvery(
    GET_HIRE_CANDIDATE_RESUME_DETAILS,
    getHiredCandidateResumeHandler,
  );
  yield takeEvery(
    GET_SHORTLIST_FILTER_DATA,
    getShortListedSortCandidateshandler,
  );
  yield takeEvery(GET_INTERVIEW_QUESTION_LIST, getInterviewQuestionListHandler);
  yield takeEvery(
    GET_INTERVIEW_QUESTION_REVIEW_LIST,
    getInterviewQuestionReviewListHandler,
  );
  yield takeEvery(
    GET_INTERVIEW_QUESTION_LIST_ID,
    getInterviewQuestionListByIdHandler,
  );
}

export default submitFeedBackSaga;
